export default "__VITE_ASSET__Cuynl0Va__"